import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  /** Signed integer magnitude already in display units (e.g. signals count
   *  difference, or whole-percent visibility change). Null/0 → renders nothing
   *  (we only surface an actual up/down change, never a "0" no-change marker). */
  value: number | null;
  className?: string;
};

/** Run-over-run change chip (proto `.delta`): up = green, down = red. Renders
 *  nothing when there's no change or no prior run. The signed magnitude is real
 *  text and the direction is also given as an aria-label (chevrons are
 *  decorative / aria-hidden) so it isn't color-only. */
export function Delta({ value, className }: Props) {
  if (value == null || value === 0) return null;
  const up = value > 0;
  const mag = Math.abs(value);
  return (
    <span
      className={cn("vb-delta", up ? "vb-delta--up" : "vb-delta--down", className)}
      aria-label={`${up ? "up" : "down"} ${mag}`}
    >
      {up ? <ChevronUp aria-hidden="true" /> : <ChevronDown aria-hidden="true" />}
      {mag}
    </span>
  );
}

export default Delta;
